export default async function request(options) {
    let action = options.action;
    if (options.method.toUpperCase() === 'GET') {
        let dataStr = ''; //数据拼接字符串
        Object.keys(options.data).forEach(key => {
            dataStr += key + '=' + options.data[key] + '&';
        })
        if (dataStr !== '') {
            dataStr = dataStr.slice(0, dataStr.lastIndexOf('&'));
            action = action + '?' + dataStr;
        }
    }

    let requestConfig = {
        credentials: 'same-origin',
        method: options.method.toUpperCase(),
        headers: options.headers,
        mode: "cors", // 用来决定是否允许跨域请求  值有 三个 same-origin，no-cors（默认）以及 cores;
        cache: "force-cache" // 是否缓存请求资源 可选值有 default 、 no-store 、 reload 、 no-cache 、 force-cache 或者 only-if-cached 。
    }

    if (options.method.toUpperCase() === 'POST') {
        Object.defineProperty(requestConfig, 'body', {
            value: JSON.stringify(options.data)
        })
    }

    try {
        const response = await fetch(action, requestConfig);
        const responseJson = await response.json()

        if(responseJson.data.list){
            responseJson.data.records = responseJson.data.list
            delete responseJson.data.list
        }
        return responseJson
    } catch (error) {
        return error
    }
}
